module.exports = __webpack_public_path__ + "static/media/GA_Feedback_2018.12.24.3a49e19e.jpg";